import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with default config
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Products API
export const productsAPI = {
  getAll: async () => {
    const response = await api.get('/products');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },
  
  getByCategory: async (category) => {
    const response = await api.get(`/products/category/${category}`);
    return response.data;
  },
  
  getFeatured: async () => {
    const response = await api.get('/products/featured/list');
    return response.data;
  }
};

// Orders API
export const ordersAPI = {
  create: async (orderData) => {
    const response = await api.post('/orders', orderData);
    return response.data;
  },
  
  getById: async (orderId) => {
    const response = await api.get(`/orders/${orderId}`);
    return response.data;
  },
  
  updateStatus: async (orderId, paymentStatus, paymentId) => {
    const response = await api.patch(`/orders/${orderId}/status`, null, {
      params: { payment_status: paymentStatus, payment_id: paymentId }
    });
    return response.data;
  }
};

// Contact API
export const contactAPI = {
  send: async (messageData) => {
    const response = await api.post('/contact', messageData);
    return response.data;
  }
};

export default api;
